import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as moment from 'moment-timezone';

if (environment.production) {
  enableProdMode();
}

moment.tz.setDefault('Etc/GMT-6');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
